/**
 * SyntheticBadge — "Synthetic data" provenance chip (CONTRACT §0.2). Every answer, output card,
 * draft and Case Page carries it.
 */

import './AgentLayout.css';

export default function SyntheticBadge({ className = '' }) {
  return (
    <span className={`agent-synth ${className}`.trim()} title="All data in this demo is synthetic">
      Synthetic data
    </span>
  );
}
